import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useGlobalSocket } from "@/context/GlobalSocket";
import { LOBBY } from "@/constants/testIds";

export default function TopNav() {
  const { user, logout } = useAuth();
  const { pendingRequestCount } = useGlobalSocket();
  const loc = useLocation();
  const nav = useNavigate();

  const linkCls = (path) =>
    `px-2.5 py-1.5 rounded-full text-[10px] sm:text-xs uppercase tracking-[0.15em] sm:tracking-[0.2em] font-semibold transition-colors ${
      loc.pathname === path ? "bg-white text-black" : "text-white/70 hover:text-white"
    }`;

  return (
    <header className="relative z-20 flex flex-wrap items-center justify-between gap-2 px-4 sm:px-10 py-3 sm:py-5 border-b border-white/5">
      <Link to="/lobby" className="flex items-center gap-2 font-display text-base sm:text-lg tracking-tighter">
        <span className="inline-block w-6 h-6 sm:w-7 sm:h-7 rounded-md" style={{background:"var(--uno-red)"}}/>
        <span>D<span style={{color:"var(--uno-yellow)"}}>O</span>S</span>
      </Link>
      <nav className="order-3 sm:order-2 flex items-center gap-1 sm:gap-2 w-full sm:w-auto justify-center sm:justify-start overflow-x-auto">
        <Link to="/lobby" className={linkCls("/lobby")}>Lobby</Link>
        <Link to="/loadout" className={linkCls("/loadout")}>Loadout</Link>
        <Link data-testid={LOBBY.storeLink} to="/store" className={linkCls("/store")}>Store</Link>
        <Link data-testid={LOBBY.friendsLink} to="/friends" className={`relative ${linkCls("/friends")}`}>
          Friends
          {pendingRequestCount > 0 && (
            <span className="absolute -top-1 -right-1 min-w-[16px] h-4 px-1 rounded-full bg-[color:var(--uno-red)] text-white text-[9px] font-bold flex items-center justify-center border border-black">
              {pendingRequestCount}
            </span>
          )}
        </Link>
        <Link data-testid={LOBBY.leaderboardLink} to="/leaderboard" className={linkCls("/leaderboard")}>Ranks</Link>
        <Link data-testid={LOBBY.profileLink} to="/profile" className={linkCls("/profile")}>Profile</Link>
        {user?.is_admin && (
          <Link to="/admin" className={`px-2.5 py-1.5 rounded-full text-[10px] sm:text-xs uppercase tracking-[0.15em] sm:tracking-[0.2em] font-semibold transition-colors ${loc.pathname === "/admin" ? "bg-[color:var(--uno-red)] text-white" : "text-[color:var(--uno-red)] hover:bg-white/5"}`}>Admin</Link>
        )}
      </nav>
      <div className="order-2 sm:order-3 flex items-center gap-2 sm:gap-3">
        <div className="flex items-center gap-1 px-2.5 py-1 rounded-full bg-white/5 border border-white/10">
          <span className="text-sm">🪙</span>
          <span className="font-display text-sm" style={{color:"var(--uno-yellow)"}}>{user?.coins ?? 0}</span>
        </div>
        <div className="hidden sm:flex items-center gap-2 pr-2">
          {user?.avatar || user?.picture ? (
            <img src={user.avatar || user.picture} alt="" className="w-8 h-8 rounded-full border border-white/20"/>
          ) : (
            <div className="w-8 h-8 rounded-full bg-white/10"/>
          )}
          <div className="text-sm text-white/80">{user?.name}</div>
        </div>
        <button
          data-testid={LOBBY.logoutBtn}
          onClick={async () => { await logout(); nav("/", { replace: true }); }}
          className="px-2.5 sm:px-3 py-1.5 rounded-full text-[10px] sm:text-xs uppercase tracking-[0.15em] text-white/70 hover:text-white border border-white/10 hover:border-white/30 transition-colors"
        >Logout</button>
      </div>
    </header>
  );
}
